import { render, staticRenderFns } from "./proposal.vue?vue&type=template&id=cc3d255e"
import script from "./proposal.vue?vue&type=script&lang=js"
export * from "./proposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports